import React, { useEffect, useState } from "react";
import { Table, Badge, Button, Spinner, Card, Alert } from "react-bootstrap";
import EncashmentsModal from "./EncashmentsModal";
import RequestWithdrawModal from "./RequestWithdrawModal";
import API from "../../api/api";
import { useAuth } from "../../context/AuthContext";

export default function Encashments() {
  const [encashments, setEncashments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [loadingWallet, setLoadingWallet] = useState(false);
  const [message, setMessage] = useState(null);

  const { user } = useAuth();
  const role = user.role;

  // Fetch all encashments
  const fetchEncashments = async () => {
    try {
      setLoading(true);
      const url =
        role === "admin" ? "/api/encashments/admin/all" : "/api/encashments/my";

      const res = await API.get(url, { withCredentials: true });
      if (res.data.success) {
        setEncashments(res.data.encashments);
      }
    } catch (err) {
      console.error("Error fetching encashments:", err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch wallet (only for distributor)
  const fetchWallet = async () => {
    if (role === "admin") return;
    try {
      setLoadingWallet(true);
      const res = await API.get("/api/encashments/wallet", {
        withCredentials: true,
      });
      if (res.data.success) {
        console.log(res.data);
        
        setWallet(res.data);
      }
    } catch (err) {
      console.error("Error fetching wallet:", err);
    } finally {
      setLoadingWallet(false);
    }
  };

  useEffect(() => {
    fetchEncashments();
    fetchWallet();
  }, [role]);

  const getStatusBadge = (status) => {
    const colors = { Approved: "success", Rejected: "danger", Pending: "warning" };
    return <Badge bg={colors[status] || "secondary"}>{status}</Badge>;
  };

  const getPaymentBadge = (paymentStatus) => {
    const colors = { Paid: "primary", Processing: "info", Unpaid: "secondary" };
    return (
      <Badge bg={colors[paymentStatus] || "secondary"}>{paymentStatus}</Badge>
    );
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Encashments</h4>
        {role !== "admin" && (
          <Button
            variant="success"
            onClick={() => setShowWithdraw(true)}
            disabled={loadingWallet || !wallet || wallet.balance <= 0}
          >
            + Request Withdraw
          </Button>
        )}
      </div>

      {/* Wallet summary for distributor */}
      {role !== "admin" && (
        <Card className="shadow-sm mb-3 p-3 text-center">
          {loadingWallet ? (
            <Spinner animation="border" size="sm" />
          ) : wallet ? (
            <div className="d-flex justify-content-around">
              <div>
                <h6>Approved Earnings</h6>
                <h5 className="text-success">Rs. {wallet.earningsTotal}</h5>
              </div>
              <div>
                <h6>Requested</h6>
                <h5 className="text-warning">Rs. {wallet.encashedTotal}</h5>
              </div>
              <div>
                <h6>Available Balance</h6>
                <h5 className="text-primary">Rs. {wallet.balance}</h5>
              </div>
            </div>
          ) : (
            <p>Error loading wallet</p>
          )}
        </Card>
      )}

      {message && <Alert variant="info">{message}</Alert>}

      {/* Encashments Table */}
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table responsive bordered hover className="mt-3 align-middle">
          <thead className="table-light">
            <tr className="text-center">
              <th>#</th>
              {role === "admin" && <th>Distributor</th>}
              <th>Amount</th>
              <th>Status</th>
              <th>Payment</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {encashments.length === 0 ? (
              <tr>
                <td colSpan={role === "admin" ? 7 : 6} className="text-center">
                  No encashments found
                </td>
              </tr>
            ) : (
              encashments.map((e, i) => (
                <tr key={e._id} className="text-center">
                  <td>{i + 1}</td>
                  {role === "admin" && (
                    <td>
                      {e.distributor?.first_name} {e.distributor?.last_name}
                      <br />
                      <small>{e.distributor?.email}</small>
                    </td>
                  )}
                  <td className="fw-bold">Rs. {e.amount}</td>
                  <td>{getStatusBadge(e.status)}</td>
                  <td>{getPaymentBadge(e.paymentStatus)}</td>
                  <td>{new Date(e.createdAt).toLocaleDateString()}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="info"
                      onClick={() => setSelected(e)}
                    >
                      View / Manage
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}

      {/* Modal for view/manage */}
      {selected && (
        <EncashmentsModal
          show={!!selected}
          handleClose={() => setSelected(null)}
          encashment={selected}
          role={role}
          onSuccess={() => {
            fetchEncashments();
            fetchWallet();
            setMessage("Encashment updated successfully.");
          }}
        />
      )}

      {/* Modal for new withdraw request */}
      {showWithdraw && (
        <RequestWithdrawModal
          show={showWithdraw}
          handleClose={() => setShowWithdraw(false)}
          onSuccess={() => {
            fetchEncashments();
            fetchWallet();
            setMessage("Withdraw request submitted successfully.");
          }}
        />
      )}
    </div>
  );
}




// import React, { useEffect, useState } from "react";
// import { Table, Badge, Button, Spinner } from "react-bootstrap";
// import EncashmentsModal from "./EncashmentsModal";
// import RequestWithdrawModal from "./RequestWithdrawModal";
// import API from "../../api/api";
// import { useAuth } from "../../context/AuthContext";

// export default function Encashments() {
//   const [encashments, setEncashments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selected, setSelected] = useState(null);
//   const [showWithdraw, setShowWithdraw] = useState(false);

//   const { user } = useAuth();
//   const role = user.role;

//   const fetchEncashments = async () => {
//     try {
//       setLoading(true);
//       const url =
//         role === "admin" ? "/api/encashments/admin/all" : "/api/encashments/my";

//       const res = await API.get(url, { withCredentials: true });
//       if (res.data.success) {
//         setEncashments(res.data.encashments);
//       }
//     } catch (err) {
//       console.error("Error fetching encashments:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEncashments();
//   }, [role]);

//   const getStatusBadge = (status) => {
//     const colors = {
//       Approved: "success",
//       Rejected: "danger",
//       Pending: "warning",
//     };
//     return <Badge bg={colors[status] || "secondary"}>{status}</Badge>;
//   };

//   const getPaymentBadge = (paymentStatus) => {
//     const colors = { Paid: "primary", Processing: "info", Unpaid: "secondary" };
//     return (
//       <Badge bg={colors[paymentStatus] || "secondary"}>{paymentStatus}</Badge>
//     );
//   };

//   return (
//     <div className="container mt-4">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4>Encashments</h4>
//         {role !== "admin" && (
//           <Button variant="success" onClick={() => setShowWithdraw(true)}>
//             + Request
//           </Button>
//         )}
//       </div>

//       {loading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" />
//         </div>
//       ) : (
//         <Table responsive bordered hover className="mt-3">
//           <thead className="table-light">
//             <tr className="text-center">
//               <th>#</th>
//               {role === "admin" && <th>Distributor</th>}
//               <th>Amount</th>
//               <th>Status</th>
//               <th>Payment</th>
//               <th>Date</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {encashments.length === 0 ? (
//               <tr>
//                 <td colSpan={role === "admin" ? 7 : 6} className="text-center">
//                   No encashments found
//                 </td>
//               </tr>
//             ) : (
//               encashments.map((e, i) => (
//                 <tr key={e._id} className="text-center">
//                   <td>{i + 1}</td>
//                   {role === "admin" && (
//                     <td>
//                       {e.distributor?.first_name} {e.distributor?.last_name}
//                       <br />
//                       <small>{e.distributor?.email}</small>
//                     </td>
//                   )}
//                   <td>Rs. {e.amount}</td>
//                   <td>{getStatusBadge(e.status)}</td>
//                   <td>{getPaymentBadge(e.paymentStatus)}</td>
//                   <td>{new Date(e.createdAt).toLocaleDateString()}</td>
//                   <td>
//                     <Button
//                       size="sm"
//                       variant="info"
//                       onClick={() => setSelected(e)}
//                     >
//                       View / Manage
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </Table>
//       )}

//       {selected && (
//         <EncashmentsModal
//           show={!!selected}
//           handleClose={() => setSelected(null)}
//           encashment={selected}
//           role={role}
//           onSuccess={fetchEncashments}
//         />
//       )}

//       {showWithdraw && (
//         <RequestWithdrawModal
//           show={showWithdraw}
//           handleClose={() => setShowWithdraw(false)}
//           onSuccess={fetchEncashments}
//         />
//       )}
//     </div>
//   );
// }
